/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function() {
  $('.p-hd').each(function(index, el) {
    const $hd = $(this);
    const $nav = $('.p-hd__nav');
    let timer;
    let timer2;
    let isSc = false;

    run();

    $(window).on('scroll', function(event) {
      run();
    });

    function run() {
      if($(window).scrollTop() > 10) {
        if(!isSc) {
          isSc = true;

          $nav.stop().fadeOut(300, 'linear', function(){});

          timer = setTimeout(function(){
            $hd.addClass('is-sc');
          }, 310);

          timer2 = setTimeout(function(){
            $nav.removeAttr('style');
          }, 320);
        }
      } else {
        if(isSc) {
          isSc = false;

          clearTimeout(timer);
          clearTimeout(timer2);
          $nav.stop().removeAttr('style');

          $hd.removeClass('is-sc');
        }
      }
    }
  });
});

$(function() {
  $('.p-hd__menu').each(function(index, el) {
    const $menu = $(this);
    const $menuLink = $menu.find('a');
    const $nav = $('.p-hd__nav');

    $menuLink.on('click', function(event) {
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  });
});

$(function() {
  $('.p-shopSlider__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      dots: true,
      variableWidth: true,
      centerMode: true,
      arrows: false
    });
  });
});

$(function() {
  $('.p-feaSlider__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      dots: true,
      variableWidth: true,
      centerMode: true,
      arrows: true
    });
  });
});

$(function() {
  $('.home-kv__ttl').each(function(index, el) {
    const $ttl = $(this);

    run();

    $(window).on('scroll', function(event) {
      run();
    });

    function run() {
      if($(window).scrollTop() > 10) {
        $ttl.removeClass('is-show');
      } else {
        $ttl.addClass('is-show');
      }
    }
  });
});

$(function() {
  $('.js-tags').each(function(index, el) {
    const $root = $(this);
    const $link = $root.find('.js-tags__link');

    $link.on('click', function(event) {
      $link.removeClass('is-cr');
      $(this).addClass('is-cr');

      let tar = $(this).attr('data-target');
      let slug = $(this).attr('data-slug');
      run(tar, slug);
    });

    $link.eq(0).trigger('click');

    function run(tar, slug) {
      const tar2 = $('.js-tags__target[data-id="' + tar + '"]');

      tar2.hide().filter('[data-slug="' + slug + '"]').stop().fadeIn();
    }
  });
});